import ArtworkGallery from "./ArtworkGallery";
import { useParams } from "react-router-dom";
import Artwork from "./Artwork";

const HomepageArtworks = () => {

    const { code } = useParams();


    return (
        <>
            {code ? 
                <Artwork code={code} />
            :
                <ArtworkGallery />
            }
        </>
    );
}


export default HomepageArtworks;